import { Game, Schedule } from "@aura-frontend/omnibus-az-client";

import { GameType, isPractice } from "@/components/EventForm/EventForm.schema";

import { getTeamNames } from "./eventUtils";

const PRACTICE_LABELS: Record<"bullpen" | "batting_practice", string> = {
  bullpen: "Bullpen",
  batting_practice: "Batting Practice",
};

function pickGame(schedule: Schedule): Game | undefined {
  return schedule.merged?.game ?? undefined;
}

function pickScheduleName(schedule: Schedule): string | undefined {
  return schedule.merged?.name ?? undefined;
}

export function getScheduleEventName(schedule: Schedule): string {
  const game = pickGame(schedule);
  const type = game?.type as GameType | undefined;

  if (game && type === "game") {
    const { homeTeamName, awayTeamName } = getTeamNames(game);
    return `${homeTeamName} x ${awayTeamName}`;
  }

  if (type && isPractice(type)) {
    const label = PRACTICE_LABELS[type];
    const name = pickScheduleName(schedule);
    return name ? `${name} (${label})` : label;
  }

  return pickScheduleName(schedule) ?? "Event";
}
